module.exports = __webpack_public_path__ + "img/fruit_pinapple.5e255367.png";